import { PermissionContext } from '../types';
import { canDo } from '../canDo';
import { permissionsOperations } from '../permissionsOperations';

export const canCreateGraphFilter = (
  permissionContext: PermissionContext
): boolean => {
  if (!permissionsOperations.isLoadedPermissionContext(permissionContext)) {
    return false;
  }

  return canDo({
    permissionContext,
    action: 'organization/create_gremlin',
    resourceId: permissionsOperations.getOrgIdFromContext(permissionContext),
  });
};
